import { models } from '@kurtosys/ksys-app-template';
export const AUTHENTICATION: models.appsInitialize.IAppAuthentication = {
	token: '',
	serviceUrl: 'https://api-local.fundpress.io',
};